import dynamic from 'next/dynamic'

import { shouldUseDesignSystem } from '@src/utils/should-use-design-system'

import BundleProductImagesLegacy, { type BundleProductImagesProps } from './bundle-product-images-legacy'

// Dynamic-import the DS twin so its web-ui + Panda bundle stays off the legacy path.
const BundleProductImagesDS = dynamic(
  () => import(/* webpackChunkName: "bundle-product-images-ds" */ './bundle-product-images-ds'),
)

const BundleProductImages = (props: BundleProductImagesProps) => {
  if (shouldUseDesignSystem()) {
    return <BundleProductImagesDS {...props} />
  }
  return <BundleProductImagesLegacy {...props} />
}

export default BundleProductImages
